"use client";

export default function StatsSection() {
  const partners = [
  {
    id: 'microsoft',
    name: 'Microsoft',
    logo: 'https://img-prod-cms-rt-microsoft-com.akamaized.net/cms/api/am/imageFileData/RE1Mu3b?ver=5c31',
    alt: 'Microsoft Partner logo'
  },
  {
    id: 'unifi',
    name: 'Unifi',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_129c12caa-1770012580092.png",
    alt: 'Unifi partner logo'
  },
  {
    id: 'dell',
    name: 'Dell',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_12154500a-1770012581925.png",
    alt: 'Dell partner logo'
  },
  {
    id: 'bitdefender',
    name: 'BitDefender',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1d88f342c-1770012580299.png",
    alt: 'BitDefender partner logo'
  }];


  return (
    <section className="py-32 px-6 bg-black border-t border-border">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="label-micro text-primary mb-4 block">
            OUR PARTNERS
          </span>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tighter uppercase">
            Trusted Technology Partners
          </h2>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 md:gap-20 items-center">
          {partners?.map((partner, index) =>
          <div
            key={partner?.id}
            className="flex items-center justify-center relative animate-scale-in"
            style={{ animationDelay: `${index * 0.1}s` }}>

              {index === 0 &&
            <div className="absolute -top-12 left-1/2 -translate-x-1/2 w-4 h-4 bg-primary shadow-[0_0_15px] shadow-primary/50" />
            }
              <div className="w-full h-24 flex items-center justify-center p-4 grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100">
                <img
                src={partner?.logo}
                alt={partner?.alt}
                className="max-w-full max-h-full object-contain" />

              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}